module.exports = __webpack_public_path__ + "img/gys_6@2x.f29deb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/gys_6@2x.png
// module id = Cle8
// module chunks = 0